import { Route, Routes } from "react-router-dom";
import { Suspense, lazy, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Loader from "../Components/kits/Loader/Loader.tsx";
import ProtectedRoute from "./ProtectedRoute.tsx";
import DiscountProduct from "pages/DiscountProduct.jsx";
import AboutUs from "pages/AboutUs.jsx";
import ContactUs from "pages/ContactUs.jsx";
import FinanceManagement from "Components/finance/index.jsx";
import OrderPayment from "pages/OrderPayment.jsx";
import ValidationProductFactor from "Components/Pages/validation-product-factor/index.jsx";
import { routes_title } from "utils/helperFunctions.js";
import useAxios from "services/useAxios.tsx";
import ReportProductFactor from "Components/Pages/report-product-factor/index.jsx";
import DownloadProduct from "pages/DownloadProduct.jsx";
import Visit from "pages/Visit.jsx";

const Home = lazy(() => import("../Components/Pages/Home/Home"));
const Category = lazy(() => import("../Components/Pages/Category"));
const Layout = lazy(() => import("../Components/layout/Layout"));
const Profile = lazy(() => import("../Components/profile/Profile"));
const CustomerOrders = lazy(() => import("../pages/CustomerOrders"));
const AdminFactor = lazy(() => import("../pages/AdminFactor"));
const PrintButton = lazy(() =>
  import("../../src/Components/Pages/Home/barcode.jsx")
);
const UserManagement = lazy(() => import("../pages/User_Management"));
const CategoryManagement = lazy(() =>
  import("../Components/CategoryManagement/CategoryManagement")
);
const OptionManagement = lazy(() =>
  import("../Components/admin-panel/option-management/OptionManagement")
);
const CustomerClub = lazy(() =>
  import("../Components/customerClub/CustomerClub.js")
);
const Setting = lazy(() =>
  import("../Components/admin-panel/setting/index.jsx")
);
const SingleProduct = lazy(() =>
  import("../Components/Pages/single-product/SingleProduct")
);
const DetailPost = lazy(() => import("../pages/post/Index"));
const Blog = lazy(() => import("../pages/Blog"));
const FactorPage = lazy(() => import("../Components/Pages/FactorPage.jsx"));
const Product = lazy(() => import("../pages/ProductListPage.jsx"));
const Report = lazy(() => import("../Components/admin-panel/report"));
const BankInfo = lazy(() => import("../Components/admin-panel/bank-info"));
export default function Router() {
  const { pathname, search, hash } = useLocation();
  const { execute: addVisitApi } = useAxios("referral/add_visit");

  useEffect(() => {
    console.log("pathname", pathname);
    console.log("pathname", search);
    let title = "";
    let titleTemp = routes_title?.find((v) => v?.route == pathname)?.title;
    let titleTemp1 = routes_title?.find((v) =>
      pathname.includes(v?.route)
    )?.title;
    if (pathname == "/") {
      title = "خانه";
    } else if (titleTemp != undefined) {
      title = titleTemp;
    } else if (titleTemp1 != undefined) {
      let id = pathname?.split("/");
      let idTemp = id?.[id?.length - 1];
      title = `${titleTemp1} با شناسه ${idTemp}`;
    }
    let payload = {
      route: `${pathname}${search}`,
      side: 0,
      title,
    };
    addVisitApi(payload);
  }, [pathname]);

  return (
    <Suspense
      fallback={
        <div className="min-vh-100 min-vw-100 d-flex justify-content-center align-items-center">
          <Loader width={40} />
        </div>
      }
    >
      <Routes>
        <Route
          path=""
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
        <Route
          path="blog/:id?"
          element={
            <Layout>
              <Blog />
            </Layout>
          }
        />
        <Route
          path="products"
          element={
            <Layout>
              <Product />
            </Layout>
          }
        />
        <Route
          path="category/:id"
          element={
            <Layout>
              <Category />
            </Layout>
          }
        />
        <Route
          path="admin-panel/orders"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <AdminFactor />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/user-management"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <UserManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/category-management"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <CategoryManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/option-management"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <OptionManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/customer-club"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <CustomerClub />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="print"
          element={
            <Layout>
              <PrintButton selectedNumber={13791379} />
            </Layout>
          }
        />

        <Route
          path="admin-panel/setting"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <Setting />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/factors"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <FactorPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/reports"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <Report />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/finance"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <FinanceManagement />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/bank-info"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <BankInfo />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="customer-panel/profile"
          element={
            <ProtectedRoute>
              <Layout pageType="user">
                <Profile />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="customer-panel/orders"
          element={
            <ProtectedRoute>
              <Layout pageType="user">
                <CustomerOrders />
              </Layout>
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="admin-panel/validation-product-factor"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <ValidationProductFactor />
              </Layout>
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="admin-panel/report-product-factor"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <ReportProductFactor />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="admin-panel/visits"
          element={
            <ProtectedRoute>
              <Layout pageType="admin">
                <Visit />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route path="compare" element={<>compare</>} />
        <Route
          path="product/:id/:referral?"
          element={
            <Layout>
              <SingleProduct />
            </Layout>
          }
        />
        <Route
          path="blog/post/:id"
          element={
            <Layout>
              <DetailPost />
            </Layout>
          }
        />
        <Route
          path="discount-product"
          element={
            <Layout>
              <DiscountProduct />
            </Layout>
          }
        />
        <Route
          path="about-us"
          element={
            <Layout>
              <AboutUs />
            </Layout>
          }
        />
        <Route
          path="contact-us"
          element={
            <Layout>
              <AboutUs />

              {/* <ContactUs /> */}
            </Layout>
          }
        />
        <Route
          path="order-payment/:orderId"
          element={
            <Layout>
              <OrderPayment />{" "}
            </Layout>
          }
        />
        <Route
          path="download-product"
          element={
            // <Layout>
            <DownloadProduct />
            // </Layout>
          }
        />
      </Routes>
    </Suspense>
  );
}
